// use vite proxy in development to avoid cors issues
export const BACKEND_URL = import.meta.env.DEV
  ? "http://localhost:3000"
  : "https://api.clove.moe";
